// Copyright 2026 NXGN Management, LLC. All Rights Reserved.
import {
  Flex as NextGenFlex,
  Tag,
  FormItem as NextGenFormItem,
} from '@teamnine/pcj-ui-v2'
import styled from 'styled-components'

export const Flex = styled(NextGenFlex)`
  min-width: 0;
  flex: 1;
`

export const CustomTag = styled(Tag)`
  flex-shrink: 0;
`

export const FormItem = styled(NextGenFormItem)`
  && .nextgen-select-selection-item {
    padding-inline-end: 24px;
  }
`
